import React from 'react';

import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';

const ConnectingBar = () => (
  <div style={{ height: 30, content: '', width: 1, background: '#d1d1d1', margin: '0 auto' }} />
);

export const AutomationTimelineBlock = ({
  title,
  isFirst,
  isLast,
  icon,
}: {
  title: string;
  isFirst?: boolean;
  isLast?: boolean;
  icon?: React.ReactNode;
}) => (
  <>
    {!isFirst && <ConnectingBar />}
    <div className="u-display-flex u-justifyContent-center">
      <div
        className="u-display-inlineFlex u-alignItems-center u-justifyContent-center u-background-white u-padding-y-sm u-minWidth-300px"
        style={{ border: '1px solid #d1d1d1' }}
      >
        {icon || <MaterialDesignIcon iconName={ICON_NAMES.EVENT} />}
        <div className="u-color-primary u-margin-left-sm typo-medium">{title.toUpperCase()}</div>
      </div>
    </div>
    {!isLast && <ConnectingBar />}
  </>
);
